import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import Switcher from '../shared/switcher/Switcher';
import SoftSkillsCommunityVsOffered from './charts/SoftSkillsCommunityVsOffered';
import {
  EXPERIENCEBYROLETABS,
  HERODATA,
  LEASTWANTEDTECHSTABS,
  MOSTUSEDTECHSTABS
} from './Talent.constants';
import { StyledSection } from './Talent.styled';

const Talent: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const heroData = HERODATA(t);
  const mostUsedTechTabs = MOSTUSEDTECHSTABS(t);
  const leastWantedTechTabs = LEASTWANTEDTECHSTABS(t);
  const experienceByRoleTabs = EXPERIENCEBYROLETABS(t);

  return (
    <StyledSection>
      <SectionHero
        background={getPublicPath(
          '/images/stateSector/2023/talent-hero-bg.webp'
        )}
        backgroundSm={getPublicPath(
          '/images/stateSector/2023/talent-hero-bg-sm.webp'
        )}
        title={t('mandecar23.talent.hero.title')}
        desc={t('mandecar23.talent.hero.desc')}
        data={heroData}
      />
      <SectionChart
        title={t('mandecar23.talent.most-used-techs.title')}
        desc={t('mandecar23.talent.most-used-techs.desc')}
        descExtra={t('mandecar23.talent.most-used-techs.descExtra')}
      >
        <Switcher
          tabsName={mostUsedTechTabs.tabsName}
          tabs={mostUsedTechTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.talent.least-wanted-techs.title')}
        desc={t('mandecar23.talent.least-wanted-techs.desc')}
        descExtra={t('mandecar23.talent.least-wanted-techs.descExtra')}
      >
        <Switcher
          tabsName={leastWantedTechTabs.tabsName}
          tabs={leastWantedTechTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.talent.main-techs.title')}
        desc={t('mandecar23.talent.main-techs.desc')}
        descExtra={t('mandecar23.talent.main-techs.descExtra')}
      >
        <Switcher
          tabsName={experienceByRoleTabs.tabsName}
          tabs={experienceByRoleTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.talent.competences.title')}
        desc={t('mandecar23.talent.competences.desc')}
        descExtra={t('mandecar23.talent.competences.descExtra')}
      >
        <SoftSkillsCommunityVsOffered />
      </SectionChart>
    </StyledSection>
  );
};

export default Talent;
